import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Input, Row, Switch } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ref } from 'firebase/storage';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

// import '@ant-design/compatible/assets/index.css';


import checkPermission from '../../../../components/Authorization/Util';
import UserContext from '../../../layout/UserContext';
import '../../../../assets/textDirection.css';
import DocumentUploader from '../../../../nextgen/components/image-upload/DocumentUploader';

const { TextArea } = Input;

const Language = ({
  reportData,
  form,
  langCode,
  language,
  defaultLang,
  submit,
}) => {
  const { t } = useTranslation();
  const [requiredDetails, setRequiredDetails] = useState(false);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (reportData?.audioList) {
      setFileList(reportData?.audioList)
    } else {
      setFileList([]);
    }
  }, [reportData])

  useEffect(() => {
    form.setFieldsValue({
      ['audioList-' + langCode]: fileList,
    });
  }, [fileList])

  const handleStateChanged = value => {
    if (value) {
      setRequiredDetails(true);
    } else {
      setRequiredDetails(false);
    }
  };

  const { getFieldDecorator } = form;
  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    (<div>
      <Row>
        <Col span={13}>
          <Card bordered={false}>
            {!defaultLang ? (
              <Form.Item label={t('appCms.poi.published')}>
                {getFieldDecorator('state-' + langCode, {
                  valuePropName: 'checked',
                  initialValue:
                    reportData &&
                    reportData.state &&
                    reportData.state === 'PUBLISHED',
                })(
                  <Switch
                    checkedChildren={t('appCms.poi.published')}
                    unCheckedChildren={t('appCms.poi.inheritFromDefault')}
                    disabled={disable}
                    // defaultChecked
                    onChange={handleStateChanged}
                  />,
                )}
              </Form.Item>
            ) : (
              ''
            )}

            <Form.Item label={t('appCms.poi.fieldTitle')}>
              {getFieldDecorator('title-' + langCode, {
                rules:
                  defaultLang || requiredDetails
                    ? [
                      {
                        required: true,
                        message: t('appCms.poi.titleRequired'),
                      },
                    ]
                    : [],
                initialValue: reportData ? reportData.title : undefined,
              })(
                <Input
                  disabled={disable}
                  className={
                    language.directionRightToLeft ? 'rightToLeftText' : ''
                  }
                />,
              )}
            </Form.Item>
            <Form.Item label={t('appCms.poi.subtitle')}>
              {getFieldDecorator('subtitle-' + langCode, {
                rules: [],
                initialValue: reportData ? reportData.subtitle : undefined,
              })(
                <TextArea
                  rows={1}
                  disabled={disable}
                  showCount
                  maxLength={60}
                  className={
                    language.directionRightToLeft ? 'rightToLeftText' : ''
                  }
                // style={() => getStyle()}
                />,
              )}
            </Form.Item>

            <Form.Item label={t('appCms.poi.description')}>
              {getFieldDecorator('description-' + langCode, {
                rules:
                  defaultLang || requiredDetails
                    ? [
                      {
                        required: true,
                        message: t('appCms.poi.descriptionRequired'),
                      },
                    ]
                    : [],
                initialValue: reportData ? reportData.description : undefined,
              })(
                <TextArea
                  rows={15}
                  disabled={disable}
                  showCount
                  maxLength={5000}
                  className={
                    language.directionRightToLeft ? 'rightToLeftText' : ''
                  }
                />,
              )}
            </Form.Item>
          </Card>
        </Col>
        <Col span={11}>
          <Card bordered={false} style={{ paddingBottom: '15px' }}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex', paddingBottom: '15px' }}
            >
              {getFieldDecorator('audioList-' + langCode, {
                valuePropName: 'file',
              })(
                <Card title={t('appCms.poi.audio')} style={{ paddingBottom: '15px' }}>
                  <Row justify="center">
                    <DocumentUploader
                      disabledAdd={!checkPermission(value, 'appcms', 'write')}
                      storageFolder={window.location.hostname.split('.')[0] + '/poiAudio-files'}
                      fileList={fileList}
                      setFileList={setFileList}
                      multiple={false}
                      maxImageSize={1}
                    />
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>)
  );
};

Language.propTypes = {
  form: PropTypes.object,
  reportData: PropTypes.object,
  langCode: PropTypes.string,
  language: PropTypes.object,
  defaultLang: PropTypes.string,
  submit: PropTypes.func,
};

Language.contextType = UserContext;

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(Language);
